export default __webpack_public_path__ + "static/media/gatsby.ed108a30.svg";